import { useUserGroups } from '@wellesley/group'
import { ToolbarItem } from '../../../common/components/ToolbarItem'
import { useActiveGroupName } from '../hooks/useActiveGroupName'
import AddGroupButton from '../AddGroupButton'
import { Compass } from 'lucide-react'
import { useVisibleItems } from 'hooks/useVisibleItems'
import { useCurrentUser } from '@wellesley/user'
import { getRoute } from '@wellesley/router'
import { GroupSideBar } from './GroupSideBar'
import { setActiveItem } from '../../../common/components/ToolbarItem/slice'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useUpdateGroupState } from './hooks/useUpdateGroupState'
import { authSlice } from '@wellesley/auth'
import { Tooltip } from '../../../common/components/Tooltip'

const Divider = () => (
  <div className="mx-auto my-s w-xl border-b border-gray-200" />
)
export const GroupsSpace = () => {
  const dispatch = useDispatch()

  const { user } = useCurrentUser()
  const isLoggedIn = useSelector(authSlice.selectors.selectIsAuthenticated)
  const activeGroupName = useActiveGroupName()

  const {
    userGroups,
    guestGroup,
    isLoading: isLoadingGroups,
  } = useUserGroups(activeGroupName || '')

  const { containerRef, visibleItemsCount } = useVisibleItems<HTMLDivElement>({
    totalItems: userGroups.length,
    maxLimit: userGroups.length,
    itemSize: 40,
    gap: 12,
    direction: 'vertical',
    hasButton: true,
    buttonSize: guestGroup ? 60 : isLoggedIn ? 40 : 80,
  })

  useUpdateGroupState(userGroups)

  useEffect(() => {
    if (activeGroupName) {
      dispatch(setActiveItem(activeGroupName))
    }
  }, [activeGroupName, dispatch])

  if (isLoadingGroups) return null

  const visibleUserGroups = userGroups.slice(0, visibleItemsCount)
  const activeUserGroup = activeGroupName
    ? userGroups.find((g) => g.groupName === activeGroupName)
    : undefined
  const isActiveGroupNotVisible =
    activeUserGroup &&
    !visibleUserGroups.some((g) => g.groupName === activeGroupName)
  const groupInTemporaryBlock =
    guestGroup ?? (isActiveGroupNotVisible ? activeUserGroup : undefined)

  return (
    <>
      <Divider />
      {groupInTemporaryBlock && (
        <>
          <GroupSideBar
            key={groupInTemporaryBlock.groupId}
            group={groupInTemporaryBlock}
          />
          <Divider />
        </>
      )}
      <div ref={containerRef} className="flex flex-1 flex-col gap-xs">
        {user && (
          <>
            {visibleUserGroups.map((group) => (
              <GroupSideBar key={group.groupId} group={group} />
            ))}
            <AddGroupButton />
          </>
        )}
        {!isLoggedIn && (
          <Tooltip tooltipText="Discover groups">
            <ToolbarItem
              id="popular-groups"
              name="Discover groups"
              link={getRoute('/discover/:category', { category: 'popular' })}
              Icon={Compass}
            />
          </Tooltip>
        )}
      </div>
    </>
  )
}
